import { AxiosResponse } from 'axios'
import { http } from '@/core/realisations/Http.realisation'

import { CreatePeriodPayload, GetPeriodByIdResponse, GetPeriodsParams, GetPeriodsResponse, UpdatePeriodPayload } from './types/periods'

type ApiGetPeriodsResponse = Promise<AxiosResponse<GetPeriodsResponse>>
type ApiGetPeriodByIdResponse = Promise<AxiosResponse<GetPeriodByIdResponse>>
type ApiCreatePeriodResponse = Promise<AxiosResponse<void>>
type ApiUpdatePeriodResponse = Promise<AxiosResponse<void>>
type ApiUpdatePeriodStatusResponse = Promise<AxiosResponse<void>>

export function getPeriods(params: GetPeriodsParams): ApiGetPeriodsResponse {
    return http.get('/dispatcher/api/period-groups', { params })
}

export function getPeriodById(periodId: number): ApiGetPeriodByIdResponse {
    return http.get(`/dispatcher/api/period-groups/${periodId}`)
}

export function createPeriod(payload: CreatePeriodPayload): ApiCreatePeriodResponse {
    return http.post('/dispatcher/api/period-groups', payload)
}

export function updatePeriod(periodId: number, payload: UpdatePeriodPayload): ApiUpdatePeriodResponse {
    return http.put(`/dispatcher/api/period-groups/${periodId}`, payload)
}

export function updatePeriodStatus(periodId: number, statusId: number): ApiUpdatePeriodStatusResponse {
    return http.put(`/dispatcher/api/period-groups/${periodId}/status`, { statusId })
}

export default {
    getPeriods,
    getPeriodById,
    createPeriod,
    updatePeriod,
    updatePeriodStatus,
}
